var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1506.54 163.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_-_Long_Blanc",
    "data-name": "Logo - Long Blanc"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.14,122.84l9.49,20.83c-12.96,12.04-31.71,18.29-48.61,18.29C36.34,161.96,0,126.31,0,82.33S36.34,2.7,81.02,2.7c16.9,0,35.65,6.02,48.61,18.05l-9.49,20.83c-10.65-10.88-22.92-16.67-40.51-16.67-31.71,0-57.41,25.7-57.41,57.41s25.69,57.41,57.41,57.41c17.59,0,29.86-5.79,40.51-16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m186.25,160.11V4.55h22.22v155.56h-22.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m403.37,4.55v159.26L273.74,31.49V.85l107.41,110.19V4.55h22.22Zm-129.63,45.71l22.22,22.34v87.51h-22.22V50.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m548.13,4.55v22.22h-88.89V4.55h88.89Zm-88.89,88.89v-21.91h77.78v21.91h-77.78Zm22.22,44.44h66.67v22.22h-88.89v-22.3h22.22v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m713.01,114.5c0,27.08-22.45,47.45-58.79,47.45s-57.41-22.45-59.72-25.23l11.11-19.91c12.96,14.35,30.79,22.92,49.07,22.92,23.38,0,36.11-9.49,36.11-24.3,0-12.5-14.12-20.14-35.42-23.84-43.29-7.41-55.56-22.92-55.56-43.75,0-25.23,19.68-45.14,56.02-45.14,6.48,0,31.02.69,50.23,18.52l-10.65,20.14c-8.1-7.87-20.6-16.44-40.05-16.44-21.29,0-33.33,8.1-33.33,21.99,0,12.04,10.65,17.59,35.19,22.45,37.04,7.18,55.79,18.98,55.79,45.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m756.49,26.38V4.55h103.71v21.83h-103.71Zm40.74,133.73V39.06h22.22v121.05h-22.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1027.01,4.55v87.04c0,40.97-18.52,70.37-59.26,70.37s-59.26-29.4-59.26-70.37V4.55h22.22v94.45c0,24.08,13.66,40.74,37.04,40.74s37.04-16.67,37.04-40.74V4.55h22.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1206.66,82.33c0,43.06-28.7,77.78-79.4,77.78h-46.53v-22.22h52.31c30.33,0,51.39-24.77,51.39-55.56s-21.07-55.55-51.39-55.55h-52.31V4.55h46.53c51.85,0,79.4,34.72,79.4,77.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1265.23,160.11V4.55h22.22v155.56h-22.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m459.33,140.38V39.57h22.22v100.81h-22.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Noir"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1444.65,81.44c-10.89,0-19.72-8.83-19.72-19.72,0-6.12,2.78-11.58,7.15-15.2-1.88-.31-3.8-.47-5.76-.47-19.48,0-35.27,15.79-35.27,35.27s15.79,35.27,35.27,35.27,35.27-15.79,35.27-35.27c0-2.78-.32-5.48-.93-8.08-3.58,4.97-9.42,8.2-16.01,8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1403.5,129.09c-17.74-8.53-30.01-26.68-30.01-47.65,0-29.14,23.7-52.84,52.84-52.84s52.84,23.7,52.84,52.84c0,8.44-1.99,16.43-5.53,23.51l6.51,3.13c.53-1.07,1.03-2.16,1.5-3.27,3.13-7.4,4.72-15.27,4.72-23.37s-1.59-15.97-4.72-23.37c-3.02-7.15-7.35-13.57-12.87-19.08-5.51-5.51-11.93-9.84-19.08-12.87-7.4-3.13-15.27-4.72-23.37-4.72s-15.97,1.59-23.37,4.72c-7.15,3.02-13.57,7.35-19.08,12.87s-9.84,11.93-12.87,19.08c-3.13,7.4-4.72,15.27-4.72,23.37s1.59,15.97,4.72,23.37c3.02,7.15,7.35,13.57,12.87,19.08,4.86,4.86,10.43,8.8,16.59,11.74l3.04-6.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1502.14,
    cy: 91.38,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1498.46,
    cy: 106.82,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1491.47,
    cy: 121.52,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1482.5,
    cy: 133.84,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1502.68,
    cy: 75.29,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1351.27,
    cy: 65.76,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1355.63,
    cy: 50.97,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1363.22,
    cy: 37.99,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1372.25,
    cy: 26.31,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1383.16,
    cy: 17.05,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1396.13,
    cy: 10.96,
    r: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1349.63,
    cy: 81.8,
    r: 3.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1426.32,153.63c-37.1,0-67.76-28.08-71.85-64.1,0,0,0,0,0,0l-8.98.71c.85,7.83,2.83,15.44,5.91,22.72,4.1,9.68,9.96,18.38,17.42,25.85,7.47,7.47,16.16,13.33,25.85,17.42,10.03,4.24,20.68,6.39,31.65,6.39s21.63-2.15,31.65-6.39c8.21-3.47,15.71-8.21,22.35-14.12l-6.08-6.69c-12.77,11.32-29.56,18.21-47.93,18.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1501.25,49.66c-4.1-9.68-9.96-18.38-17.42-25.85-7.47-7.47-16.16-13.33-25.85-17.42-10.03-4.24-20.68-6.39-31.65-6.39-7.49,0-14.83,1-21.92,2.99.49,1.46,1.96,5.91,2.83,8.57,6.09-1.67,12.49-2.56,19.09-2.56,35.19,0,64.6,25.27,71.01,58.62l8.96-1.13c-1.06-5.76-2.75-11.38-5.05-16.83Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f5657cbe23ad5023cb480374178dd2a9.svg";
export { ForwardRef as ReactComponent };